var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from '@mui/material';
import { useAnalyticsEventTracker } from '../../../../../../hooks/useAnalyticsEventTracker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import './Actions.scss';
export var Actions = function (_a) {
    var attachment = _a.attachment, setDialogData = _a.setDialogData, value = _a.value;
    var eventTracker = useAnalyticsEventTracker('Attachments Table').eventTracker;
    return (_jsx("div", { className: "Table-Actions", children: _jsx(IconButton, { "aria-label": "fitment-note", title: "Availability and Specs", onClick: function () {
                eventTracker('More Info Button clicked');
                setDialogData(__assign(__assign({ partNumber: attachment.partNumber, description: attachment.description, stock: attachment.stock, salesCode: attachment.salesCode, fitmentNotes: value }, (attachment.pickUp && attachment.pickUp !== '0'
                    ? { pickUp: attachment.pickUp }
                    : {})), { multiFunctionControlsRequired: attachment.multifunctionalControlsRequired, metric: {
                        width: attachment.widthMillimeters,
                        size: attachment.sizeMillimeters,
                        weight: attachment.weightKilograms,
                        minOperatingPressure: attachment.minOperatingPressureBar,
                        maxOperatingPressure: attachment.maxOperatingPressureBar,
                        minFlowRate: attachment.minFlowRateLMin,
                        maxFlowRate: attachment.maxFlowRateLMin,
                        torque: attachment.torqueNm,
                        pinDiameter: attachment.pinDiameterMM,
                        operatingWidth: attachment.operatingWidthMM,
                        volumeCapacity: attachment.volumeCapacityM3,
                        loadCapacity: attachment.loadCapacityKilograms,
                    }, imperial: {
                        width: attachment.widthInches,
                        size: attachment.sizeInches,
                        weight: attachment.weightPounds,
                        minOperatingPressure: attachment.minOperatingPressurePSI,
                        maxOperatingPressure: attachment.maxOperatingPressurePSI,
                        minFlowRate: attachment.minFlowRateGPM,
                        maxFlowRate: attachment.maxFlowRateGPM,
                        torque: attachment.torqueFTLB,
                        pinDiameter: attachment.pinDiameterInches,
                        operatingWidth: attachment.operatingWidthInches,
                        volumeCapacity: attachment.volumeCapacityYd3,
                        loadCapacity: attachment.loadCapacityPounds,
                    } }));
            }, children: _jsx(FontAwesomeIcon, { icon: faCircleInfo, size: "xs", color: "black" }) }) }));
};
